export class CamerasWrapper {
    _visible = false;
    images = [];
    imageWidth = 1;

    constructor(images) {
        this.images = images;
    }

    get visible() {
        return this._visible;
    }

    set visible(x) {
        this._visible = x;
        for (const image of this.images) {
            image.mesh.visible = x;
            if(x && image.texture === null)
            {
                new window.Potree.TextureLoader().load(image.id, (texture) => {
                    image.texture = texture;
                    image.mesh.material.uniforms.tColor.value = texture;
                    image.mesh.material.needsUpdate = true;
                    image.mesh.scale.set(
                        this.imageWidth,
                        (texture.image.height / texture.image.width) * this.imageWidth,
                        1
                    );
                });
            }
        }
    }
}
